import React, { useContext, useEffect, useRef, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import ToolbarIcons from '../../icons/toolbar';
import CenterModal from '../CenterModal';
import LanguageBox from '../LanguageBox';
import ThemeBox from '../ThemeBox';
import TooltipBottom from '../TooltipBottom';
import styles from './styles.module.scss';

const HeaderMoreBox = ({
  content,
  exitFunction,
  showExitButton = false,
  setShowFiles,
  showFiles,
  extraClassName = 'nothing',
  setOpenSettingMore,
  setShowThemeModal,
  setShowLanguageModal,
}) => {
  const {
    themeColor,
    direction,
    themeMode,
    showSearch,
    setShowSearch,
    setActiveMessage,
    setActiveAudio,
    openMenu,
    setOpenMenu,
    openSettingModal,
    setOpenSettingModal,
    setOpenCreateGroup,
    openUpdateProfile,
    setOpenUpdateProfile,
  } = useContext(AdminContext);

  const onChooseItem = (id) => {
    if (id == 1) {
      setActiveMessage('');
      setActiveAudio();
      setShowFiles(!showFiles);
    }
    if (id == 2) {
      exitFunction();
      setActiveMessage('');
      setActiveAudio();
      setShowThemeModal(false);
      setShowLanguageModal(false);
    }
    if (id == 3) {
      setOpenSettingModal(!openSettingModal);
    }
    if (id == 4) {
      setOpenCreateGroup(true);
    }
    if (id == 5) {
      setOpenUpdateProfile(!openUpdateProfile);
    }
    setOpenSettingMore(false);
  };

  return (
    <>
      <div className={`${styles.ProfileMenuMiddle} noBorder `}>
        <div
          className={`flex flex-col justify-start items-start ${extraClassName}`}
        >
          <>
            {content?.setting?.more?.map((item, index) => (
              // <TooltipBottom
              //   text={content?.toolbar?.fileIcon}
              //   className=" cursor-pointer h-[24px]"
              //   onClick={() => onChooseItem(item?.id)}
              // >
              //   {item?.icon}
              // </TooltipBottom>
              <>
                <div
                  className={`flex flex-row justify-start items-center my-[8px] mx-[2px] cursor-pointer`}
                  onClick={() => onChooseItem(item?.id)}
                  key={index}
                >
                  {item?.icon}
                  <div
                    className={`mx-8px ${themeMode != 'white' && 'textWhite'}`}
                  >
                    {item?.chosen}
                  </div>
                </div>
              </>
            ))}
          </>
        </div>
      </div>
    </>
  );
};

export default HeaderMoreBox;
